import React, { useState, useEffect } from 'react';
import { and, not, or } from 'ramda';
import SupportIcon from '../../../../../../assets/icons/support.svg';
import { useResponsive } from '../../../../../shared/hooks';
import { HERO_TEXT } from '../../../../constants';
import { Header } from '../../../../components';
import { HeroGrid, HeroOverlay, HeroContent, HeroIcon, HeroText } from './styles';

const Hero = ({ scrollPosition, showInMobile = false, show = true }) => {

  const { xs, sm } = useResponsive();
  const [ showHeader, setShowHeader ] = useState(false);

  useEffect(() => {
    setShowHeader(and(or(xs, sm), showInMobile));
  }, [xs, sm, showInMobile]);

  if (not(show)) {
    return <></>;
  }

  if (and(or(xs, sm), not(showInMobile))) {
    return <></>;
  }

  return (
    <HeroGrid scrollPosition={scrollPosition}>
      <HeroOverlay />
      <HeroContent>
        {
          showHeader && <Header marginBottom={'auto'} white />
        }
        <HeroIcon src={ SupportIcon } loading='lazy' alt='support icon' />
        <HeroText>{ HERO_TEXT }</HeroText>
      </HeroContent>
    </HeroGrid>
  );
}

export default Hero;
